import FullCalendar from "@fullcalendar/react";
import type { CalendarRef, DatesSetInfo, EventClickInfo, EventInput } from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/react/timegrid";
import classicThemePlugin from "@fullcalendar/react/themes/classic";
import type { RefObject } from "react";

export interface FullCalendarWeekGridProps {
  calendarRef: RefObject<CalendarRef | null>;
  initialDate: string;
  events: EventInput[];
  onDatesSet: (info: DatesSetInfo) => void;
  onEventClick: (info: EventClickInfo) => void;
}

export default function FullCalendarWeekGrid({ calendarRef, initialDate, events, onDatesSet, onEventClick }: FullCalendarWeekGridProps) {
  return <FullCalendar
    ref={calendarRef}
    plugins={[classicThemePlugin, timeGridPlugin]}
    initialView="timeGridWeek"
    initialDate={initialDate}
    firstDay={0}
    headerToolbar={false}
    allDaySlot={false}
    height="auto"
    nowIndicator
    scrollTime="05:00:00"
    slotMinTime="05:00:00"
    slotMaxTime="22:00:00"
    slotDuration="00:30:00"
    dayHeaderFormat={{ weekday: "short", month: "numeric", day: "numeric" }}
    eventTimeFormat={{ hour: "numeric", minute: "2-digit", meridiem: "short" }}
    eventMinHeight={24}
    eventClass={info => info.level === 1 ? "calendar-overlapping-event" : ""}
    editable={false}
    selectable={false}
    events={events}
    datesSet={onDatesSet}
    eventClick={onEventClick}
  />;
}
